import { TenantConfig } from './tenant-config.model';

/**
 * Config used when the tenant-config API returns nothing (unmapped origin,
 * failed request, empty DB row). An empty branding object means every
 * --ds-* custom property keeps its compiled :root value — the AR brand.
 * Absent feature flags evaluate as disabled.
 */
export const DEFAULT_TENANT_CONFIG: TenantConfig = {
  brandId: '',
  productName: '',
  companyName: '',
  branding: {},
  featureFlags: {
    experianCreditReports: false,
    experianAML: false,
    experianOpenBanking: false,
    zoomMeetings: false,
    fees: false,
    postworks: false,
    vulnerableCustomer: false
  },
  optionalContactUpdatesDefaults: false
};

/**
 * Per-tenant configuration map keyed by tenantId.
 * Used as the baseline configuration for each tenant (and for ?tenantConfig=<key>
 * dev overrides) while the tenant-config API endpoint is not yet live; any
 * fields returned by the API override these values.
 * Multiple tenants (e.g. balgores, marquis) can share a visual brandId ('mab')
 * while defining their own companyName, productName, privacyPolicyUrl, and assets.
 */
export const TENANT_CONFIGS: { [key: string]: TenantConfig } = {
  heron: {
    brandId: 'heron',
    productName: 'Everglades',
    companyName: 'Heron Financial',
    privacyPolicyUrl: 'https://heronfinancial.co.uk/privacy-policy/',
    branding: {
      logos: {
        desktopLightMode: 'assets/brand/logos/Everglades-light-bg_fg.svg',
        desktopDarkMode: 'assets/brand/logos/Everglades-dark-bg.svg',
        mobileIcon: 'assets/brand/logos/Everglades-E.svg',
        loginLogo: 'assets/brand/logos/Everglades-light-bg_fg.svg'
      },
      advisorLoginBackground: 'assets/brand/img/sign-in-family.jpg',
      clientLoginBackground: 'assets/brand/img/garden-steps.jpg'
    },
    featureFlags: {
      experianCreditReports: true,
      experianAML: true,
      experianOpenBanking: true,
      zoomMeetings: true,
      fees: false,
      postworks: false,
      vulnerableCustomer: true
    },
    optionalContactUpdatesDefaults: true
  },
  mab: {
    brandId: 'mab',
    productName: 'Mortgage Advice Bureau',
    companyName: 'Mortgage Advice Bureau',
    branding: {
      logos: {
        desktopLightMode: 'assets/brand/logos/MAB-light.png',
        desktopDarkMode: 'assets/brand/logos/MAB-dark.svg'
      },
      clientLoginBackground: 'assets/brand/img/mab-client-login-background.webp'
    },
    featureFlags: {
      experianCreditReports: true,
      experianAML: true,
      experianOpenBanking: false,
      zoomMeetings: false,
      fees: false,
      postworks: false
    },
    optionalContactUpdatesDefaults: false
  },
  balgores: {
    brandId: 'mab',
    productName: 'Balgores',
    companyName: 'Balgores',
    // privacyPolicyUrl: 'https://...', // Set once Balgores privacy policy URL is confirmed
    branding: {
      logos: {
        desktopLightMode: 'assets/brand/logos/MAB-light.png',
        desktopDarkMode: 'assets/brand/logos/MAB-dark.svg'
      },
      clientLoginBackground: 'assets/brand/img/mab-client-login-background.webp'
    },
    featureFlags: {
      experianCreditReports: true,
      experianAML: true,
      experianOpenBanking: false,
      zoomMeetings: false,
      fees: false,
      postworks: false
    },
    optionalContactUpdatesDefaults: false
  },
  marquis: {
    brandId: 'mab',
    productName: 'Marquis',
    companyName: 'Marquis',
    // privacyPolicyUrl: 'https://...', // Set once Marquis privacy policy URL is confirmed
    branding: {
      logos: {
        desktopLightMode: 'assets/brand/logos/MAB-light.png',
        desktopDarkMode: 'assets/brand/logos/MAB-dark.svg'
      },
      clientLoginBackground: 'assets/brand/img/mab-client-login-background.webp'
    },
    featureFlags: {
      experianCreditReports: true,
      experianAML: true,
      experianOpenBanking: false,
      zoomMeetings: false,
      fees: false,
      postworks: false
    },
    optionalContactUpdatesDefaults: false
  },
  citrus: {
    brandId: 'citrus',
    productName: 'Citrus',
    companyName: 'Citrus Financial',
    // privacyPolicyUrl: 'https://...', // Set once Citrus privacy policy URL is confirmed
    branding: {
      logos: { desktopLightMode: 'assets/brand/logos/MAB-light.png' }
    },
    featureFlags: {
      experianCreditReports: false,
      experianAML: false,
      experianOpenBanking: false,
      zoomMeetings: false,
      fees: false,
      postworks: false
    },
    optionalContactUpdatesDefaults: false
  }
};
